import { render, staticRenderFns } from "./dr-svg.vue?vue&type=template&id=b917d8c0&"
import script from "./dr-svg.vue?vue&type=script&lang=js&"
export * from "./dr-svg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports